import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { MaterialSymbol } from 'sharetribe-client-tools';

import { ListingTag, ListingTagContainer } from '../../components';

import css from './ListingTagList.module.css';

const ListingTagList = props => {
  const { className, listing } = props;
  const intl = useIntl();

  const { publicData, metadata } = listing?.attributes || {};

  const isDryCleaned = metadata?.dryCleaned;
  const neverWorn = publicData?.condition === 'new';
  const nonAltered = publicData?.altered === false;
  const receiptConfirmed = metadata?.receipt;

  if (!isDryCleaned && !neverWorn && !nonAltered && !receiptConfirmed) return null;

  const dryCleanedLabel = intl.formatMessage({ id: 'ListingTagList.dryCleaned' });
  const neverWornLabel = intl.formatMessage({ id: 'ListingTagList.neverWorn' });
  const nonAlteredLabel = intl.formatMessage({ id: 'ListingTagList.nonAltered' });
  const receiptAvailableLabel = intl.formatMessage({ id: 'ListingTagList.receiptAvailable' });

  const classes = classNames(css.root, className);
  const getTagClasses = isActive => classNames(css.tag, { [css.disabled]: !isActive });

  return (
    <ListingTagContainer className={classes}>
      {isDryCleaned ? (
        <ListingTag
          className={css.tag}
          text={dryCleanedLabel}
          symbol={<MaterialSymbol symbol="water_drop" />}
        />
      ) : null}
      {neverWorn ? (
        <ListingTag
          className={css.tag}
          text={neverWornLabel}
          symbol={<MaterialSymbol symbol="sell" />}
        />
      ) : null}
      {nonAltered ? (
        <ListingTag
          className={css.tag}
          text={nonAlteredLabel}
          symbol={<MaterialSymbol symbol="square_foot" />}
        />
      ) : null}
      {receiptConfirmed ? (
        <ListingTag
          className={css.tag}
          text={receiptAvailableLabel}
          symbol={<MaterialSymbol symbol="receipt_long" />}
        />
      ) : null}
    </ListingTagContainer>
  );
};

export default ListingTagList;
